const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay, addWheelControls } =
  window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class AnnouncementBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentIndex = 0
    this.isMobile = null
    this.allSlides = []
  }

  connectedCallback () {
    super.connectedCallback()

    this.allSlides = this.els.slide?.exists ? [...this.els.slide.elements] : []

    this.syncSlideVisibility()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleResize = debounce(this.handleResize.bind(this), 250)
    this.listeners.add(window, 'resize', this.handleResize)

    if (this.els?.link?.exists) {
      this.handleLinkClick = this.handleLinkClick.bind(this)

      this.els.link.elements.forEach((link) => {
        this.listeners.add(link, 'click', this.handleLinkClick)
      })
    }

    if (!this.els?.dismiss?.exists) return

    this.handleDismiss = this.handleDismiss.bind(this)
    this.listeners.add(this.els.dismiss.element, 'click', this.handleDismiss)
  }

  handleResize () {
    if (this.isMobile === window.BAO.MediaBreakpoints.isXsViewport) return

    this.syncSlideVisibility()

    if (!this.carousel) {
      this.carousel = this.setupCarousel()
      return
    }

    this.carousel.update()
    this.onSlideChanged(this.carousel)
  }

  syncSlideVisibility () {
    this.isMobile = window.BAO.MediaBreakpoints.isXsViewport

    const container = this.els.slides.element

    this.allSlides.forEach((slide) => {
      const visibility =
        slide.querySelector('[data-announcement-visibility]')?.dataset
          .announcementVisibility || 'all'
      const shouldShow =
        visibility === 'all' ||
        (visibility === 'mobile' && this.isMobile) ||
        (visibility === 'desktop' && !this.isMobile)

      slide.remove()

      if (shouldShow) container.appendChild(slide)
    })

    Array.from(container.children).forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== 0)
    })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useAutoplay(this.autoplay, { pauseOnHover: true }),
        addWheelControls('horizontal'),
      ],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.currentIndex = currentSlide

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  handleLinkClick (event) {
    const text = event.currentTarget.getAttribute('aria-label')

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'announcement_bar_interaction',
      target_text: text,
      target_index: this.currentIndex,
    })
  }

  async handleDismiss () {
    this.classList.toggle('sec-AnnouncementBar-hidden')

    await window.BAO.Cart.updateCartAttributes({
      dismissed_announcement: this.announcementId,
    })
  }

  get autoplay () {
    return parseInt(this.dataset.autoplay)
  }

  get announcementId () {
    return this.dataset.announcementId
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
